import { render, staticRenderFns } from "./CvatDataTable.vue?vue&type=template&id=009d861f&scoped=true"
import script from "./CvatDataTable.vue?vue&type=script&lang=js"
export * from "./CvatDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009d861f",
  null
  
)

export default component.exports